function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__9fbc3f13-ae70-421e-bb5b-0be70de337d9",
  d: "M96 100.5L32 72v65.4a4 4 0 002.4 3.6l58.4 25.5a7.9 7.9 0 006.4 0l58.4-25.5a3.9 3.9 0 002.4-3.7V72z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__65610b2a-4afc-42e3-a610-b51abf63b02a",
  d: "M157.6 139l-58.4 25.6a7.9 7.9 0 01-6.4 0L34.4 139a3.9 3.9 0 01-2.4-3.7v2a4 4 0 002.4 3.7l58.4 25.5a7.9 7.9 0 006.4 0l58.4-25.5a3.9 3.9 0 002.4-3.7v-2a3.9 3.9 0 01-2.4 3.7z",
  fill: "#f0f0f0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__a127ff7f-f4e6-42f2-8b95-cfa85038721d",
  d: "M96 44.4L32 74 13.8 56.4c-1-1-1-4.4.2-5l56-24.5a4 4 0 014.2.5zM96 44.4L160 74l18.2-17.6c1-1 1-4.4-.2-5l-56-24.5a4 4 0 00-4.2.5z",
  fill: "#f4f4f4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__43a1eb4c-2f8d-45af-ae7b-31a93540608f",
  d: "M96 44.4L32 74 13.8 56.4c-1-1-1-4.4.2-5l56-24.5a4 4 0 014.2.5zM96 44.4L160 74l18.2-17.6c1-1 1-4.4-.2-5l-56-24.5a4 4 0 00-4.2.5z",
  fill: "#e6e6e6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__65610b2a-4afc-42e3-a610-b51abf63b02a",
  d: "M96 100.5v66.8a7.1 7.1 0 003.2-.7l58.4-25.6a3.9 3.9 0 002.4-3.7V72z",
  fill: "#f0f0f0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__359f08b4-9b19-44c0-b06a-7d513ec86486",
  d: "M157.6 139.1l-58.4 25.6a8.8 8.8 0 01-3.2.7v2a7.1 7.1 0 003.2-.7l58.4-25.5a3.9 3.9 0 002.4-3.7v-2a4 4 0 01-2.4 3.6z",
  fill: "#e2e2e2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__9fbc3f13-ae70-421e-bb5b-0be70de337d9",
  d: "M96 42.4L32 72 13.8 54.4a2 2 0 01-.1-2.8l.6-.4L70 24.9a4 4 0 014.2.5zM96 42.4L160 72l18.2-17.6a2 2 0 00.1-2.8l-.6-.4L122 24.9a4 4 0 00-4.2.5z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__d14b55e5-6e88-4c01-8396-ed3b40e0a9f8",
  fill: "#c80813",
  d: "M96 100.6L32 72l64-29.6v58.2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__904459d0-edb5-4ece-8bbd-afc2062445d7",
  fill: "#e60000",
  d: "M96 100.6L160 72 96 42.4v58.2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__9fbc3f13-ae70-421e-bb5b-0be70de337d9",
  d: "M177.2 100.1L160 72l-64 28.6 17.5 30.3a4 4 0 005.2 1.6l56.8-26.7a3.9 3.9 0 002-5.2h-.1a.8.8 0 00-.2-.5zM14.8 100.1L32 72l64 28.6-17.5 30.3a4 4 0 01-5.2 1.6l-56.8-26.7a3.9 3.9 0 01-2-5.2h.1a.8.8 0 01.2-.5z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__1fd6033f-7191-4446-91f1-e48890a80dea",
  d: "M96 100.5l-17.5 30.3a4 4 0 01-5.2 1.6L45 119.2l47.1 47.1.7.3a8.8 8.8 0 003.2.7z",
  fill: "#ccc"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__fd30a40b-0e7a-4716-b61f-0700b316be8f",
  d: "M175.5 103.8l-56.8 26.7a4 4 0 01-5.2-1.6l-16.6-28.7-.9.4 17.5 30.3a4 4 0 005.2 1.6l56.8-26.7a4.1 4.1 0 002.2-4.6 3.8 3.8 0 01-2.2 2.6zM78.5 128.9a4 4 0 01-5.2 1.6l-56.8-26.7a4.1 4.1 0 01-2.2-2.6 3.9 3.9 0 002.2 4.6l56.8 26.7a4 4 0 005.2-1.6L96 100.5l-.9-.4z",
  fill: "#e0e0e0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "bundles-hi-dark_svg__14d53d1e-9b3a-45a5-bb21-e3acba567ba1",
  fill: "none",
  d: "M0 0h192v192H0z"
});

var SvgBundlesHiDark = function SvgBundlesHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "d1b6dd33-06ff-43f7-a363-99c3ba9c0fce",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default SvgBundlesHiDark;